import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { ProjectOfferResponse } from '@/models/MyProjects';
import ProjectOffersListItem from '@/views/project-forum/components/sidebar-actions/ProjectOffersListItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOffersList',
  props: {
  title: {
    type: String,
    default: ''
  },
  offers: {
    type: Array as PropType<ProjectOfferResponse[]>,
    default: () => []
  }
},
  setup(__props) {




return { __sfc: true,ProjectOffersListItem }
}

})